export const PRICE_PROFITABILITY_SUCCESS = 'PRICE_PROFITABILITY_SUCCESS';
export const IS_PRICE_PROFITABILITY_LOADING_TOGGLE = 'IS_PRICE_PROFITABILITY_LOADING_TOGGLE';
export const BOOSTED_PRODUCT_SET_SUCCESS = 'BOOSTED_PRODUCT_SET_SUCCESS';
export const BOOSTED_MENU_PRODUCT_SET_SUCCESS = 'BOOSTED_MENU_PRODUCT_SET_SUCCESS';
export const RESET_MENU_ENGINEERING_PROFITABILITY = 'RESET_MENU_ENGINEERING_PROFITABILITY';
